import {
	Box,
	Button,
	Checkbox,
	Dialog,
	Field,
	Flex,
	Input,
	Portal,
	Separator,
	Stack,
	Text,
} from '@welbe/design-system';
import { CompanyPermissions } from 'constants/companyPermissions';
import { LuUser } from 'react-icons/lu';
import { useAddProfileDialog } from './AddProfileDialog.hooks';

type AddProfileDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
};

export const AddProfileDialog = ({
	open,
	setOpen,
}: AddProfileDialogProps): JSX.Element => {
	const {
		name,
		permissions,
		fieldsWithErrors,
		isLoading,
		setName,
		handleTogglePermission,
		handleConfirm,
	} = useAddProfileDialog({ open, setOpen });

	return (
		<Dialog.Root
			open={open}
			lazyMount
			onOpenChange={(details: { open: boolean }) => setOpen(details.open)}
		>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content animation="slideIn" width="480px" maxWidth="95vw">
						<Dialog.Header>
							<Flex gap="3" alignItems="center">
								<Box
									w="38px"
									h="38px"
									bg="blue.500"
									borderRadius="md"
									display="flex"
									alignItems="center"
									justifyContent="center"
								>
									<LuUser color="white" size={24} />
								</Box>
								<Stack gap="0">
									<Dialog.Title>Agregar perfil de permisos</Dialog.Title>
								</Stack>
							</Flex>
						</Dialog.Header>
						<Separator />
						<Dialog.Body padding="1.5rem">
							<Stack gap="1.25rem">
								<Field.Root invalid={!!fieldsWithErrors.name} required>
									<Field.Label>
										Nombre del nuevo perfil <Field.RequiredIndicator />
									</Field.Label>
									<Input
										name="name"
										placeholder="Escribe el nombre"
										background="white"
										value={name}
										onChange={({ target }) => setName(target.value)}
										disabled={isLoading}
									/>
									<Field.ErrorText>{fieldsWithErrors.name}</Field.ErrorText>
								</Field.Root>

								<Stack gap="0.75rem" w="100%">
									{Object.values(CompanyPermissions).map((permission) => (
										<Checkbox.Snippet
											key={permission.id}
											checked={permissions.includes(permission.id)}
											disabled={isLoading}
											onCheckedChange={({ checked }: { checked: boolean }) =>
												handleTogglePermission(permission.id, checked === true)
											}
										>
											{permission.name}
										</Checkbox.Snippet>
									))}
									{fieldsWithErrors.permissions && (
										<Text color="red.500" fontSize="0.875rem">
											{fieldsWithErrors.permissions}
										</Text>
									)}
								</Stack>
							</Stack>
						</Dialog.Body>
						<Dialog.Footer
							padding="1.5rem"
							borderTop="1px solid"
							borderColor="gray.200"
							gap={2}
						>
							<Button
								variant="outline"
								onClick={() => setOpen(false)}
								disabled={isLoading}
							>
								Cancelar
							</Button>
							<Button onClick={handleConfirm} loading={isLoading}>
								Confirmar
							</Button>
						</Dialog.Footer>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
